module.exports = __webpack_public_path__ + "static/media/bathroom-cleaning.dce06bdb.png";